<template>
<div class="chapter">
<div class="inner_page">
<p class="label" id="page_15"><a id="pt2"></a>Part 2</p>
<p class="h2a">Price and Prejudice</p>
<p class="noindent">The essay in this section is taken from my book <em>The Economics of Discrimination</em>, first published in 1957, which was a greatly revised version of a 1955 Ph.D. dissertation with the more attractive title “Discrimination in the Market Place.” It was my first published effort to apply the economic approach to a problem outside of conventional fields of economics, and was greeted with indifference or hostility by the overwhelming majority of the economics profession. (In 1956 a prominent young economist expressed surprise at learning that I was working on racial discrimination, saying that I was supposed to be a neoclassical type economist. My attempt to explain why my study was an application of neo-classical economics was greeted very skeptically.) The reception among some sociologists and other social scientists was, on the other hand, surprisingly (to me!) favorable, at least to judge by their book reviews.</p>
<p class="indent">In the mid-sixties, stimulated by the civil rights movement, economists began seriously to study racial discrimination and, a few years later, discrimination against women. Numerous studies since then have applied the economic approach to different minorities, and “minority economics” is a thriving field today.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780226217062_07_pt2.vue?390ef633